<template>
  <v-row
    justify="space-between"
    class="head-search ma-0">
    <v-col
      cols="12"
      md="3"
      lg="2">
      <v-select
        v-model="filter.campaign"
        :items="campaigns"
        label="ช่องทาง"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col
      cols="12"
      md="3"
      lg="2">
      <v-select
        v-model="filter.status"
        :items="statuses"
        label="สถานะ"
        outlined
        hide-details
        dense />
    </v-col>
    <v-col
      cols="12"
      md="3"
      lg="2">
      <v-select
        v-model="filter.promotionType"
        :items="promotionTypes"
        label="ประเภท"
        outlined
        hide-details
        dense />
    </v-col>
    <v-spacer />
    <v-col
      cols="12"
      md="5"
      lg="4"
      class="d-flex flex-row justify-center align-center"
      style="gap: 1rem;">
      <v-text-field
        v-model="filter.search"
        dense
        label="ค้นหา"
        hide-details
        outlined
        @keydown.enter="filterClicked" />
      <v-btn
        color="primary"
        class="filter-btn"
        @click="filterClicked()">
        ค้นหา
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      offset-md="9"
      offset-lg="10"
      md="3"
      lg="2">
      <v-spacer />
      <v-btn
        block
        color="primary"
        :to="{ name: 'CreatePromotion'}">
        สร้างโค้ด
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      searching: null,
      statuses: [
        { text: 'ทั้งหมด', value: '' },
        { divider: true },
        { text: 'ใช้งานแล้ว', value: 'used' },
        { text: 'ยังไม่ใช่งาน', value: 'unuse' },
        { text: 'ปิดการใช้งาน', value: 'inactive' }
      ],
      campaigns: [
        { text: 'ทั้งหมด', value: 'all' },
        { divider: true },
        { text: 'แบรนด์', value: 'brand_campaign' },
        { text: 'VIP', value: 'member_campaign' },
        { text: 'ซื้อครั้งแรก', value: 'first_online_purchase' },
        { text: 'Super Campaign', value: 'super_campaign' }
      ],
      promotionTypes: [
        { text: 'ทั้งหมด', value: null },
        { divider: true },
        { text: 'Member', value: 'MEMBER' },
        { text: 'Marketing', value: 'MARKETING' },
        { text: 'Store Credit', value: 'STORE_CREDIT' },
        { text: 'Gift Voucher', value: 'GIFT_VOUCHER' },
        { text: 'Giveaway', value: 'GIVEAWAY' },
        { text: 'Celeb', value: 'CELEB' },
        { text: 'Employee Benefits', value: 'EMPLOYEE_BENEFITS' }
      ]
    }
  },
  computed: {
    filter () {
      return this.value
    }
  },
  methods: {
    filterClicked () {
      this.$emit('filter-clicked', this.filter)
    }
  }
}
</script>
